import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('pricing');

export class ProductWithPrice extends Api {
  constructor(http, config = {}) {
    super(http, url, 'products-with-price', config);
  }
}
